import { atom } from 'jotai';
import { Order } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type Orders = {
  orders: Array<Order>;
};

export const ordersAtom = atom<LoadableState<Orders>>(Loadable.uninitialized);
